import React, { useState, useEffect } from "react";
import { Table, Typography, Button } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import Pageloader from "../../../../components/loader";
import TableCaret from "../../../../components/tableCaret/tableCaret";
import BreakModal from "../breakModal";
import moment from "moment";
import * as breakActions from "../../../../redux/actions/break.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { userhasPermissionHelper } from "../../../../utils/Helpers";
import { PERMISSION_CONSTANT } from "../../../../utils/constants/app";

const {Text}=Typography;
const BreakTable = (props) => {
  const [postData, setPostData] = useState(null);
  const [postDataPagi, setPostPagi] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    try {
      setLoading(true);
      if (props.taskListData && props.taskPagination)
        setPostData(props.taskListData);
    } catch (e) {} finally {
      setLoading(false);
    }
  }, [props.taskListData]);

  useEffect(() => {
    if (props.storeIdsFilter) {
      postLists(props.storeIdsFilter);
    }
  }, [props.storeIdsFilter]);
  
  const postLists = async (data) => {
    try {
      setLoading(true);
      if (data)
        await props.breakActions.breakListAction(data);
    } catch (e) {} finally {
      setLoading(false);
    }
  };

  const paginationChange = async (page, limit) => {
    const pageData = {
      ...props.storeIdsFilter,
      currentPage: page,
      limit: limit,
    };
    try {
      setLoading(true);
      await props.breakActions.breakListFilterAction(pageData);
    } catch (e) {} finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: 'Shift ID',
      render: (value) => {
            return value && value.shift_id ? value.shift_id : "-" ;
          },
      dataIndex: 'break_timing',
      key: 'shift_id',
    },
    {
      title: 'Mart',
      render: (value) => {
            return value && value.store_name ? value.store_name : "-" ;
          },
      dataIndex: 'break_timing',
      key: 'store_name',
    },
    {
      title: 'Rider ID',
      dataIndex: 'display_id',
      key: 'display_id',
    },
    {
      title: 'Name',
      dataIndex: 'fullName',
      key: 'fullName',
    },
    {
      title: ()=><div>Break planned start time</div>,
      render: (value) => {
        return <><span>{moment(value.start_time).format("DD MMMM, yyyy")}</span><p>{moment(value.start_time).format("h:mm A")}</p></>;
      },
      dataIndex: 'break_timing',
      key: 'break_timing',
    },
    {
      title: ()=><div>Break planned end time</div>,
      render: (value) => {
        return <><span>{moment(value.end_time).format("DD MMMM, yyyy")}</span><p>{moment(value.end_time).format("h:mm A")}</p></>;
      },
      dataIndex: 'break_timing',
      key: 'break_timing',
    },
    // {
    //   title: 'Actual break end time',
    //   render: (value) => {
    //     return value && value.actual_end_time ? <><span>{moment(value.actual_end_time).format("DD MMMM, yyyy")}</span><p>{moment(value.actual_end_time).format("h:mm A")}</p></>:"-";
    //   },
    //   dataIndex: 'actual_end_time',
    //   key: 'actual_end_time',
    // },
    {
      title: 'Duration',
      render: (value) => {
        var ms = moment(moment().format("DD/MM/YYY HH:mm:ss"),"DD/MM/YYYY HH:mm:ss").diff(moment(moment(value.start_time).format("DD/MM/YYY HH:mm:ss"),"DD/MM/YYYY HH:mm:ss"));
        var d = moment.duration(ms);
        return d ? (moment().format("DD/MM/YYY HH:mm:ss") >= moment(value.end_time).format("DD/MM/YYY HH:mm:ss")) ? "0":
          <Text>
            <span>{d._data.days === 0?"":d._data.days+"Day"}</span>
            <p>{('0'+d._data.hours).slice(-2)}h {('0'+d._data.minutes).slice(-2)}min</p>
          </Text>: "-";
      },
      dataIndex: 'break_timing',
      key: 'duration',
    },
    {
      title: 'Remaining',
      render: (value) => {
        var ms = moment(moment(value.end_time).format("DD/MM/YYY HH:mm:ss"),"DD/MM/YYYY HH:mm:ss").diff(moment(moment().format("DD/MM/YYY HH:mm:ss"),"DD/MM/YYYY HH:mm:ss"));
        var d = moment.duration(ms);
        return d ? (moment().format("DD/MM/YYY HH:mm:ss") >= moment(value.end_time).format("DD/MM/YYY HH:mm:ss")) ? "0":
          <Text>
            <span>{d._data.days === 0?"":d._data.days+"Day"}</span>
            <p>{('0'+d._data.hours).slice(-2)}h {('0'+d._data.minutes).slice(-2)}min</p>
          </Text>: "-";
      },
      dataIndex: 'break_timing',
      key: 'remaining',
    },
    {
      title: 'Reason',
      render: (value) => {
        return value && value.reason ? value.reason:"-";
      },
      dataIndex: 'break_timing',
      key: 'reason',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: 'Action',
      render: (value) => {
        return <>
          {userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_END_BREAK) &&
            <Button type="primary" onClick={()=>showModal(value)}><EllipsisOutlined /></Button>
          }
        </>;
      },
      dataIndex: 'id',
      key: 'id',
    },
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenID, setIsModalOpenID] = useState(null);
  const showModal = (value) => {
    setIsModalOpenID(value)
    setIsModalOpen(true);
  };
  const postDataRefresh = () => {
  postLists(props.storeIdsFilter);
  }

  var _ = require('lodash');
  const [sc, setsc] = useState({
    value:  "",
    sort:  'desc',
  })
  const sorting = (value) => {
    if (value && value === sc.value){
      if (sc.sort === 'desc'){
        setPostData(_.orderBy(Object.values(props.taskListData), [value], ['asc']));
        setsc({ value:  value, sort:  'asc' })
      }else {
        setPostData(_.orderBy(Object.values(props.taskListData), [value], ['desc']));
        setsc({ value:  value, sort:  'desc' })
      }
    } else {
      setPostData(_.orderBy(Object.values(props.taskListData), [value], ['desc']));
      setsc({ value:  value, sort:  'desc' })
    }
  }

  return loading ? (
    <Pageloader />
  ) : (
    <>
      <BreakModal 
        postData={isModalOpenID}
        postDataRefresh={postDataRefresh}
        visible={isModalOpen}
        setvisible={setIsModalOpen}
      />
      <Table
        dataSource={postData}
        columns={columns}
        pagination={{
          total: props.taskPagination && props.taskPagination.totalCount,
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
          pageSize: props.taskPagination && props.taskPagination.limit,
          defaultCurrent: props.taskPagination && props.taskPagination.currentPage,
          pageSizeOptions: ["10", "20", "30", "40", "50"],
          showSizeChanger: true,
          onChange: (currentPage, pageSize) => {
            paginationChange(currentPage, pageSize);
          },
        }}
        // onRow={(r) => ({
        //   onDoubleClick: (e) => window.open(`/overview/${r._id}`),
        // })}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    taskListData: state.BreakReducer.taskData,
    storeIdsFilter: state.BreakReducer.taskFilter,
    taskPagination: state.BreakReducer.taskPagination,
    permissions: state.PermissionReducer.permissions,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    breakActions: bindActionCreators(breakActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BreakTable);